import Vue from "vue";

export class PlanoInternet {
    static create() {
        return {
            valor: 0,
            nome: null,
            megas: 0
        };
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static byID(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("plano_internet/" + id)
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param id
     * @returns {Promise}
     */
    static excluir(id) {
        return new Promise((resolve, reject) => {
            Vue.http
                .delete("plano_internet/" + id)
                .then(() => resolve(), err => reject(err));
        });
    }

    /**
     *
     * @return {Promise}
     */
    static all() {
        return new Promise((resolve, reject) => {
            Vue.http
                .get("plano_internet")
                .then(res => resolve(res.data), err => reject(err));
        });
    }

    /**
     *
     * @param data
     * @return {Promise}
     */
    static save(data) {
        return new Promise((resolve, reject) => {
            let promisse = null;

            if (data._id) {
                promisse = Vue.http.put("plano_internet", data);
            } else {
                promisse = Vue.http.post("plano_internet", data);
            }

            promisse.then(() => resolve(), err => reject(err));
        });
    }
}
